$(document).ready(function() {
  if($('.how-does-work_row').length != 0){
    var init = false;
    function swiperCard() {          
      if (window.innerWidth <= 768) {        
        if (!init) {
          init = true;
          swiper = new Swiper(".how-does-work_row", {
            slidesPerView: 1,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
          });
        }
      } else if (init) {
        swiper.destroy();
        init = false;
      }
    }
    swiperCard();
    window.addEventListener("resize", swiperCard);    
  }

  if($(".image_testimonial .image_testimonial_slider").length){
    swiper = new Swiper(".image_testimonial_slider", {
      slidesPerView: 4,
      spaceBetween: 65,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
     },
     pagination: {
       el: ".swiper-pagination",
       clickable: true,
     },
     breakpoints: {
       1400: {
         spaceBetween: 65,
       },
       1200: {
         spaceBetween: 55,
       },
       991: {
         spaceBetween: 40,
       },
       767: {
         slidesPerView: 3,
         spaceBetween: 30,
       },
       575: {
         slidesPerView: 2,
         spaceBetween: 20,
       },
       0: {
         slidesPerView: 1,
         spaceBetween: 0,
       }
     },  
    });
  }

  if($(".review_inner").length){
    swiper = new Swiper(".review_inner", {
      slidesPerView: 3,
      spaceBetween: 49,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
     },
     pagination: {
       el: ".swiper-pagination",
       clickable: true,
     },
     breakpoints: {
       1400: {
         spaceBetween: 40,
       },
       991: {
         spaceBetween: 30,
       },
       767: {
         slidesPerView: 2,
         spaceBetween: 20,
       },
       640: {         
         slidesPerView: 2,
         spaceBetween: 10,
       },
       0: {
         slidesPerView: 1,
         spaceBetween: 0,
       }
     },  
    });
  } 

  if($('.ingredients_section_bottom_block').length != 0){
      var init = false;
      function swiper__Card() {
        if (window.innerWidth <= 768) {
          if (!init) {
            init = true;
            swiper = new Swiper(".ingredients_section_bottom_block", {
             slidesPerView: "auto",
             spaceBetween: 10,
              navigation: {
                nextEl: ".ingredients_section_bottom_block .swiper-button-next",
                prevEl: ".ingredients_section_bottom_block .swiper-button-prev",
              },
              pagination: {
                el: ".swiper-pagination",
                clickable: true,
              },
            });
          }
        } else if (init) {
          swiper.destroy();
          init = false;
        }
      }
      swiper__Card();
      window.addEventListener("resize", swiper__Card);
    }  
  
var custom_pro_slider_thumsslider = new Swiper(".custom_pro_slider_thumsslider", {
      spaceBetween: 10,
     slidesPerView: 5,
      breakpoints: {
         991: {
           spaceBetween: 20,
          slidesPerView: 5,
          freeMode: true,
          watchSlidesProgress: true,
          slideToClickedSlide: true,
        },
      },
    });
    var custom_pro_slider = new Swiper(".custom_pro_slider", {
      spaceBetween: 10,
      navigation: {
        nextEl: ".custom_pro_slider .swiper-button-next",
        prevEl: ".custom_pro_slider .swiper-button-prev",
     },
      thumbs: {
        swiper: custom_pro_slider_thumsslider,
      },
    });

  var dublicat_custom_pro_slider_thumsslider = new Swiper(".dublicat_custom_pro_slider_thumsslider", {
      spaceBetween: 10,
     slidesPerView: 5,
      breakpoints: {
         991: {
           spaceBetween: 20,
          slidesPerView: 5,
          freeMode: true,
          watchSlidesProgress: true,
          slideToClickedSlide: true,
        },
      },
    });
    var dublicat_custom_pro_slider = new Swiper(".dublicat_custom_pro_slider", {
      spaceBetween: 10,
      navigation: {
        nextEl: ".dublicat_custom_pro_slider .swiper-button-next",
        prevEl: ".dublicat_custom_pro_slider .swiper-button-prev",
     },
      thumbs: {
        swiper: dublicat_custom_pro_slider_thumsslider,
      },
    });

});